module.exports = __webpack_public_path__ + "img/20240523_tiankang.d2e2a21e.jpg";